"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMBytecodeFormat = void 0;
const Utils_1 = require("../../utils/Utils");
exports.VMBytecodeFormat = Utils_1.Utils.makeEnum({
    Json: 'json',
    Binary: 'binary'
});
